var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVeriffLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 81,
    viewBox: "0 0 288 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5309 67.5437C23.4943 62.3253 21.1623 55.161 13.302 32.8727H0L18.2254 79.1298H30.6633L47.9387 32.8723H34.8957C27.4674 54.7183 25.3947 61.706 24.5309 67.5434V67.5437Z",
    fill: "#03282C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4156 31.8987C57.7685 31.8987 48.0937 42.2468 48.0937 56.1333C48.0937 70.4612 58.1133 80.0134 72.1063 80.0134C80.9963 80.0134 88.5949 75.2922 92.2067 68.5589L83.0759 63.4744C81.2618 67.1004 77.548 69.6653 72.1929 69.6653C65.8877 69.6653 60.964 65.5966 60.3595 59.9365H94.6504C95.2552 41.3623 85.149 31.8987 71.4156 31.8987ZM60.2733 51.1797C60.705 45.7848 65.2829 41.9816 71.4156 41.9816C77.5484 41.9816 81.9532 45.7848 82.2125 51.1797H60.2733Z",
    fill: "#03282C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M143.885 32.8723H131.62V79.1298H143.885V32.8723Z",
    fill: "#03282C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M203.491 22.6122C205.132 22.6122 207.033 22.8774 208.933 23.4078V13.3252C206.86 12.6179 204.01 12.0865 201.16 12.0865C193.04 12.0865 184.921 16.509 184.921 29.5989V32.8718H167.033V31.368C166.342 24.7344 168.933 22.6122 173.339 22.6122C174.98 22.6122 176.88 22.8774 178.78 23.4078V13.3252C176.707 12.6179 173.857 12.0865 171.007 12.0865C162.888 12.0865 154.768 16.509 154.768 29.5989V32.8718H149.412V42.6855H154.768V79.1289H167.033V42.6855H184.921V79.1289H197.186V42.6855H208.933V32.8718H197.186V31.368C196.495 24.7344 199.086 22.6122 203.491 22.6122Z",
    fill: "#03282C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113.006 47.0469V45.2407L111.672 32.8729H101V79.13H113.006V60.3851C113.006 50.6072 119.599 44.5432 126.834 44.5432V32.3422C118.339 33.2078 113.006 38.2151 113.006 47.0472V47.0469Z",
    fill: "#03282C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M143.983 16.1622H131.52V26.2296H143.983V16.1622Z",
    fill: "#03282C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M263.084 32.4668V63.6903L263.188 63.6889C265.236 47.9167 274.348 37.6081 288 32.701V0.921692C272.3 3.72566 263.084 13.8901 263.084 32.4668Z",
    fill: "#14E5C5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M233.807 59.1712L258.723 80.201V38.491L233.807 17.4612V59.1712Z",
    fill: "#14E5C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeriffLogo);
export default __webpack_public_path__ + "static/media/veriff_logo.da0a771aea58e3734d1567c99e6557a0.svg";
export { ForwardRef as ReactComponent };